import { handleActions } from 'redux-actions'
import * as type from './type'
import { MODE_MONTHLY } from './const'
import { COMPANY_CODE_SUNSHINE_SMILE_GERMANY } from '../../../internationalization/const'

const today = new Date()

export const initialState = {
    funnelStartTime: {
        month: today.getMonth() + 1,
        year: today.getFullYear(),
        companyCode: COMPANY_CODE_SUNSHINE_SMILE_GERMANY,
    },
    currentState: null,
    mode: MODE_MONTHLY,
    funnelStepList: [
        {
            processName: 'salesorder-set',
            stateName: 'new',
        },
        {
            processName: null,
            stateName: null,
        },
    ],
    cohortList: [],
    fetching: false,
    error: null,
}


export default handleActions({

    [type.CHANGE_MODE]: (state, action) => {
        const { mode } = action.payload
        return {
            ...state,
            mode,
        }
    },
    [type.CHANGE_FUNNEL_START_DEFINITION]: (state, action) => {
        const { name, value } = action.payload
        return {
            ...state,
            funnelStartTime: {
                ...state.funnelStartTime,
                [name]: value,
            },
        }
    },
    [type.CHANGE_FUNNEL_STEP]: (state, action) => {
        const { name, value, funnelStepIndex } = action.payload
        const _funnelStep = state.funnelStepList[funnelStepIndex]

        // todo: clean up
        state.funnelStepList[funnelStepIndex] = {
            ..._funnelStep,
            [name]: value,
        }

        if (funnelStepIndex === state.funnelStepList.length - 1) {
            state.funnelStepList.push({
                processName: null,
                stateName: null,
            })
        }

        return {
            ...state,
            funnelStepList: [
                ...state.funnelStepList,
            ],
        }
    },
    [type.FIND_COHORT_REQUEST]: (state, action) => {
        return {
            ...state,
            cohortList: [],
            fetching: true,
        }
    },
    [type.FIND_COHORT_SUCCESS]: (state, action) => {
        const { cohortList } = action.payload
        return {
            ...state,
            cohortList,
            fetching: false,
        }
    },
    [type.FIND_CURRENT_STATE_SUCCESS]: (state, action) => {
        const { currentState } = action.payload
        return {
            ...state,
            currentState,
        }
    },
    [type.FIND_COHORT_ERROR]: (state, action) => {
        const { error } = action.payload
        return {
            ...state,
            fetching: false,
            error,
        }
    },


}, initialState)



// WEBPACK FOOTER //
// ./src/modules/analytics/state/funnel-builder/reducer.js